import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { Contents } from './components/sections/Contents';
import { Deliverables } from './components/sections/Deliverables';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full overflow-x-hidden bg-white" data-id="element-0" data-mp="23v2td3l0915e">
      <MetaPixel data-id="element-1" data-mp="3ikqy1x7ax04o" />
      <Hero data-id="element-2" data-mp="3ij668fcdfvai" />
      <main data-id="element-3" data-mp="3ijpbowku4r7n">
        <BeforeAfter data-id="element-4" data-mp="3ihv0i9zd8dgr" />
        <PainPoints data-id="element-5" data-mp="3mlj6io8cn0zw" />
        <Contents data-id="element-6" data-mp="3mkre1ma1tjdu" />
        <Deliverables data-id="element-7" data-mp="3mk868ye44bdj" />
        <Bonuses data-id="element-8" data-mp="3mjpyb4i388ps" />
        <Offer data-id="element-9" data-mp="3mj6lg27aoaim" />
        <Guarantee data-id="element-10" data-mp="3rcj8i7wbs999" />
        <Testimonials data-id="element-11" data-mp="3rbzq6q2rjiup" />
        <About data-id="element-12" data-mp="3rcsyvwla8ifh" />
        <FAQ data-id="element-13" data-mp="3recf5n6xuth9" />
        <FinalCTA data-id="element-14" data-mp="3relvsk63foaa" />
      </main>
      <Footer data-id="element-15" data-mp="67z9oh5w26u" />
      <FloatingCTA data-id="element-16" data-mp="4ww9qvjiygs" />
      <PurchasePopup data-id="element-17" data-mp="5gbgztt38r4" />
    </div>;
}